__turbopack_context__.v({
  "className": "plus_jakarta_sans_d77f0525-module__CKjd-W__className",
  "variable": "plus_jakarta_sans_d77f0525-module__CKjd-W__variable",
});
